import styled from "styled-components";

// tslint:disable-next-line
export const ManagerSearchFilterBottomContainer = styled.div``;
